import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import SelectableContainer from '../SelectableContainer/index.js';

/**
 *  `SelectableTabs` create a tabbed content container using `SelectableContainer`s for navigating the content.
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SelectableTabs(_ref) {
  let {
    children,
    defaultActiveKey = 0,
    onSelect = () => {}
  } = _ref;
  const [selectedTab, setSelectedTab] = useState(defaultActiveKey);
  useEffect(() => {
    setSelectedTab(defaultActiveKey);
  }, [defaultActiveKey]);
  const handleSelect = event => {
    setSelectedTab(Number(event.currentTarget?.dataset?.tabIndex));
    onSelect(event, event.currentTarget.getAttribute('id'));
  };
  const renderNavItems = () => React.Children.map(children, (child, index) => {
    const inputProps = {
      ...child.props.inputProps,
      'data-tab-index': index
    };
    return /*#__PURE__*/_jsxs(SelectableContainer, {
      inputProps: inputProps,
      checked: selectedTab === index,
      containerClasses: "display-flex flex-1",
      onChange: handleSelect,
      children: [/*#__PURE__*/_jsx(React.Fragment, {
        children: child.props.tabHeaderContent
      }, "tab-header-content"), child.props.icon && /*#__PURE__*/_jsx("span", {
        className: "badge badge-circle padding-1",
        children: child.props.icon
      }, "icon")]
    }, inputProps.id);
  });
  const renderContent = () => React.Children.map(children, (child, index) => selectedTab === index ? child : null);
  if (!children) return null;
  return /*#__PURE__*/_jsxs("div", {
    "data-cmp": "selectableTabs",
    className: "selectable-tabs margin-top-5",
    children: [/*#__PURE__*/_jsx("div", {
      className: "selectable-tab-header",
      children: renderNavItems()
    }), /*#__PURE__*/_jsx("div", {
      className: "margin-top-3",
      children: renderContent()
    })]
  });
}
export default SelectableTabs;